// Adaptive wrapper for Module3_3 - preserves original architecture with instance selector
import React from 'react';
import AssessmentWrapper from '../../AssessmentWrapper';
import Module3_3 from './index';

const AdaptiveModule3Original = (props) => (
  <AssessmentWrapper 
    moduleType="3" 
    isAdaptive={true}
    onModuleComplete={props.onModuleComplete}
    renderAdaptiveContent={(contentProps) => (
      <Module3_3 
        {...props}
        instanceData={contentProps.instance}
        onSubmit={contentProps.onSubmit}
        instanceNumber={contentProps.instanceNumber}
      />
    )}
  />
);

export default AdaptiveModule3Original;